<template>
  <section id="alerts">
      <main style="text-align:left;white-space:normal">
  <!--       <div class="title">
            <icon icoClass='title-ico' selected='indicators'/>
            {{$t('alerts')}}
        </div> -->
        <div class="alert" v-if="alerts.length">
            <img v-if="alerts[index]" :src="alerts[index].type.media" alt="Alert">
        </div>
      </main>
    </section>
</template>

<script>
import icon from './../svg/tabs'
import {mapActions, mapState} from 'vuex'
export default {
  name: 'alerts',
  components: {icon},
  props: {
  },
  created () {
    this.$emit('loading')
  },
  mounted () {
    this.$nextTick(() => {
      this.timer = setInterval(() => {
        // eslint-disable-next-line
        if (this.$route.name != 'alerts') {
          clearInterval(this.timer)
        } else if (this.userData.roles && this.userData.roles.map((x) => { return x.id }).indexOf(this.kioskId) > -1) {
          ++this.index
          if (this.index >= this.alerts.length) {
            this.$emit('next')
          }
        }
      }, (process.env.REFRESH_TIME * 1000))
    })
    this.getAlerts({method: 'get', url: 'api/alerts', headers: {area: 'G', company: 1}}).then((response) => {
      this.alerts = response
    })
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  data () {
    return {
      index: 0,
      alerts: [],
      timer: undefined
    }
  },
  computed: {
    ...mapState({
      userData: state => state.auth.userData,
      kioskId: state => state.auth.kiosk.id
    })
  },
  methods: {
    ...mapActions({
      getAlerts: 'requestIndicators'
    })
  }
}
</script>

<style scoped lang="scss">
.alert {
  text-align: center;
  img {
    margin: 0;
    object-fit: fill;
    height: 75vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PageAlerts.vue